import React, {useMemo} from 'react';

import {View} from 'react-native';

import {Table} from '../../../../../../shared/components/table';
import {Column} from '../../../../../../shared/components/table/model';
import {RequestResponsePayload} from '../../../../../../shared/models/api';

import {ViewProps} from './model';
import getStyles from './styles';
import {IconColumn, TopicColumn, DateOfApplicationColumn, TimeColumn, RequestIdColumn} from './columns';

export default ({requests}: ViewProps) => {
  const styles = getStyles();
  const columns: Column<RequestResponsePayload>[] = useMemo(
    () => [
      {
        title: '№',
        titleTestID: 'requestId-column-id',
        render: (request) => <RequestIdColumn request={request} styles={styles} />,
        field: 'id',
        headStyles: {
          colHeadStyle: styles.colRequestId,
        },
        styles: {
          colBodyStyle: [styles.colBody, styles.colRequestId],
        },
      },
      {
        title: '',
        titleTestID: 'is-read-request-column-id',
        render: (request) => <IconColumn request={request} styles={styles} />,
        field: 'isRead',
      },
      {
        title: 'Тема обращения',
        titleTestID: 'topic-column-id',
        render: (request) => <TopicColumn request={request} />,
        field: 'topic',
        headStyles: {
          colHeadStyle: styles.colText,
        },
        styles: {
          colBodyStyle: [styles.colBody, styles.colText],
        },
      },
      {
        title: 'Дата подачи',
        titleNumberOfLines: 1,
        titleTestID: 'dateTime-column-id',
        render: (request) => <DateOfApplicationColumn request={request} styles={styles} />,
        field: 'dateTime',
        headStyles: {
          colHeadStyle: styles.colDate,
        },
        styles: {
          colBodyStyle: [styles.colBody, styles.colDate],
        },
      },
      {
        title: 'Время',
        titleTestID: 'dateTime-second-column-id',
        render: (request) => <TimeColumn request={request} styles={styles} />,
        field: 'dateTime',
        headStyles: {
          colHeadStyle: styles.colTime,
        },
        styles: {
          colBodyStyle: [styles.colBody, styles.colTime],
        },
      },
    ],
    [styles],
  );
  return (
    <View>
      <Table data={requests} columns={columns} testIdPrefix='request-row' />
    </View>
  );
};
